/* tslint:disable */
/* eslint-disable */
export enum CountiesEnum {
  Ab = 'AB',
  Ar = 'AR',
  Ag = 'AG',
  Bc = 'BC',
  Bh = 'BH',
  Bn = 'BN',
  Bt = 'BT',
  Br = 'BR',
  Bv = 'BV',
  B = 'B',
  Bz = 'BZ',
  Cl = 'CL',
  Cs = 'CS',
  Cj = 'CJ',
  Ct = 'CT',
  Cv = 'CV',
  Db = 'DB',
  Dj = 'DJ',
  Gl = 'GL',
  Gr = 'GR',
  Gj = 'GJ',
  Hr = 'HR',
  Hd = 'HD',
  Il = 'IL',
  Is = 'IS',
  If = 'IF',
  Mm = 'MM',
  Mh = 'MH',
  Ms = 'MS',
  Nt = 'NT',
  Ot = 'OT',
  Ph = 'PH',
  Sj = 'SJ',
  Sm = 'SM',
  Sb = 'SB',
  Sv = 'SV',
  Tr = 'TR',
  Tm = 'TM',
  Tl = 'TL',
  Vl = 'VL',
  Vs = 'VS',
  Vn = 'VN'
}
